// src/services/apis/favoritesApi.js

const favoritesApi = (apiClient) => ({
    addFavorite: async (favorite) => {
      const response = await apiClient.post('/Stream/Favorites/AddFavorite', favorite);
      return response.data;
    },
    removeFavorite: async (id) => {
      const response = await apiClient.delete(`/Stream/Favorites/RemoveFavorite?id=${id}`);
      return response.data;
    },
    getFavorites: async () => {
      const response = await apiClient.get('/Stream/Favorites/GetFavorites');
      return response.data;
    },
  });
  
  export default favoritesApi;
  